import { createContext } from 'react'

export const ReservationCountContext = createContext({})
